import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { ionEyeOutline } from '@ng-icons/ionicons';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { JobOfferBasicResult } from 'src/app/shared/model/job-offer-result';
import { JobCardComponent } from '../job-card/job-card.component';

@Component({
  selector: 'app-list-section',
  imports: [CommonModule, RouterModule, JobCardComponent],
  templateUrl: './list-section.component.html',
  styles: ``,
  viewProviders: [provideIcons({ ionEyeOutline })],
})
export class ListSectionComponent {
  @Input() jobs: JobOfferBasicResult[] = [];
  @Input() isLoading: boolean = false;

  trackById(index: number, item: any) {
    return item.id;
  }
}
